import {useState } from "react";
import { Box, Typography } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { extractTextFromHTML } from "../../../utils/textUtils";
import { useFetchTaskActivityQuery } from "../../../slice/logdetailSlice";

const TaskActivityStream = () => {
  const { id } = useParams();
  const [showActivity, setShowActivity] = useState([]);
  const { data: task_activity_status } = useFetchTaskActivityQuery(id);

  const borderColors = ["#2196f3", "#4caf50", "#ff9800"]; // Blue, Green, Orange

  return (
    <Box className="border  rounded my-3 py-3 showActivities ">
      {task_activity_status?.map((activity, index) => {
        const [date, time] = activity.added_at.split(" ");
        // //console.log()("activitytest :", activity.added_at);

        return (
          <Box key={index} className="row" mb={3}>
            <Box className="col-md-3" textAlign="right">
              <Typography variant="body2" fontWeight="bold">
                {date}
              </Typography>
              <Typography variant="body2" className="text-rgba-gray">
                {time}
              </Typography>
            </Box>
            <Box
              className="col-md-9"
              sx={{
                borderLeft: `4px solid ${
                  borderColors[index % borderColors.length]
                }`, // Highlighted border on the left
                paddingLeft: 2,
                // borderRadius: 1,
                // backgroundColor: index % 2 === 0 ? 'rgba(0,0,0,0.04)' : 'transparent', // Optional background for alternate rows
              }}
            >
              {/* <Typography variant="body2" className="text-rgba-gray">
                {activity.added_by}
               
              </Typography>
              
              <Typography variant="body2" fontWeight="bold">
                {activity.activity_type}
              </Typography> */}
              {/* )} */}
              {/* {activity.comments && ( */}
              <Box ml={2}>
                {activity.comments.split(",").map((update, idx) => (
                  <Typography
                    sx={{ mt: 1.5 }}
                    key={idx}
                    variant="body2"
                    fontWeight="bold"
                  >
                    {extractTextFromHTML(update)}
                  </Typography>
                ))}
              </Box>
              {/* )} */}
            </Box>
            {/* {index < activities.length - 1 && <Divider className="w-100" />} */}
          </Box>
        );
      })}
    </Box>
  );
};

export default TaskActivityStream;
